import React, { useEffect, useRef, useState } from "react";

export const Counter = ({ to = 100, duration = 1800, suffix = "" }) => {
    const [val, setVal] = useState(0);
    const ref = useRef(null);
    const started = useRef(false);

    useEffect(() => {
        const el = ref.current;
        if (!el) return;
        const obs = new IntersectionObserver(
            (entries) => {
                entries.forEach((e) => {
                    if (e.isIntersecting && !started.current) {
                        started.current = true;
                        const start = performance.now();
                        const tick = (now) => {
                            const p = Math.min((now - start) / duration, 1);
                            const eased = 1 - Math.pow(1 - p, 3);
                            setVal(Math.round(to * eased));
                            if (p < 1) requestAnimationFrame(tick);
                        };
                        requestAnimationFrame(tick);
                    }
                });
            },
            { threshold: 0.3 }
        );
        obs.observe(el);
        return () => obs.disconnect();
    }, [to, duration]);

    return (
        <span ref={ref}>
            {val}
            {suffix}
        </span>
    );
};

export default Counter;
